// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Image, Alert } from 'react-bootstrap';
// import axios from 'axios';
// import { Base_Url } from '../config';

// const EditFacultyModal = ({ modal, closeModal, editObj, fetchFaculty }) => {
//   const [formData, setFormData] = useState({
//     file: null,
//     name: '',
//     title: '',
//     email: '',
//     phone: '',
//     summary: '',
//     office: '',
//     designation: '',
//     weblink: '',
//   });
  
//   const [errors, setErrors] = useState({});
//   const [previewImage, setPreviewImage] = useState(null);
//   const [submitError, setSubmitError] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     if (editObj) {
//       setFormData({
//         file: null,
//         name: editObj.name || '',
//         title: editObj.title || '',
//         email: editObj.email || '',
//         phone: editObj.phone || '',
//         summary: editObj.summary || '',
//         office: editObj.office || '',
//         designation: editObj.designation || '',
//         weblink: editObj.website || '',
//       });
//       if (editObj.image) {
//         setPreviewImage(`${Base_Url}/${editObj.image}`);
//       }
//       setErrors({});
//       setSubmitError('');
//     }
//   }, [editObj]);

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     setErrors(prev => ({ ...prev, [name]: '' }));
    
//     if (name === 'file' && files[0]) {
//       setFormData(prev => ({
//         ...prev,
//         [name]: files[0]
//       }));
//       setPreviewImage(URL.createObjectURL(files[0]));
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     }
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!formData.name?.trim()) newErrors.name = 'Name is required';
//     if (!formData.designation?.trim()) newErrors.designation = 'Designation is required';
//     if (!formData.email?.trim()) newErrors.email = 'Email is required';
//     if (!formData.phone?.trim()) newErrors.phone = 'Phone is required';
//     if (!formData.summary?.trim()) newErrors.summary = 'Work summary is required';
    
//     // Email validation
//     if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Please enter a valid email address';
//     }
    
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationErrors = validate();
    
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     setIsSubmitting(true);
//     setSubmitError('');

//     const data = new FormData();
//     if (formData.file) {
//       data.append('image', formData.file);
//     }
    
//     // Only append non-empty values
//     Object.keys(formData).forEach(key => {
//       if (key !== 'file' && formData[key]) {
//         data.append(key, formData[key]);
//       }
//     });

//     // Only append these if they exist in editObj
//     if (editObj.show_hod !== undefined) {
//       data.append('show_hod', editObj.show_hod);
//     }


//     try {
//       const response = await axios.put(`${Base_Url}/profile/${editObj.id}`, data, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         }
//       });
      
//       if (response.data) {
//         closeModal();
//         fetchFaculty();
//       }
//     } catch (error) {
//       console.error('Error updating faculty:', error);
//       setSubmitError(
//         error.response?.data?.error || 
//         error.response?.data?.message || 
//         'Failed to update faculty member. Please try again.'
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <Modal show={modal} size="xl" onHide={closeModal}>
//       <Modal.Header closeButton>
//         <Modal.Title>Edit Faculty Member</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {submitError && (
//           <Alert variant="danger" className="mb-3">
//             {submitError}
//           </Alert>
//         )}
        
//         <Form onSubmit={handleSubmit}>
//           <Form.Group controlId="formFile" className="mb-3">
//             <Form.Label>Profile Photo</Form.Label>
//             <Form.Control
//               type="file"
//               name="file"
//               onChange={handleChange}
//               accept="image/png, image/jpeg, image/jpg, image/gif"
//             />
//             {previewImage && (
//               <Image
//                 src={previewImage}
//                 alt="Preview"
//                 fluid
//                 className="mt-2"
//                 style={{ maxHeight: '200px' }}
//               />
//             )}
//           </Form.Group>

//           <Form.Group controlId="formName" className="mb-3">
//             <Form.Label>Name *</Form.Label>
//             <Form.Control
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               isInvalid={!!errors.name}
//             />
//             <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
//           </Form.Group>

//           <Form.Group controlId="formDesignation" className="mb-3">
//             <Form.Label>Designation *</Form.Label>
//             <Form.Control
//               type="text"
//               name="designation"
//               value={formData.designation}
//               onChange={handleChange}
//               isInvalid={!!errors.designation}
//             />
//             <Form.Control.Feedback type="invalid">{errors.designation}</Form.Control.Feedback>
//           </Form.Group>

//           <Form.Group controlId="formEmail" className="mb-3">
//             <Form.Label>Email *</Form.Label>
//             <Form.Control
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               isInvalid={!!errors.email}
//             />
//             <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
//           </Form.Group>

//           <Form.Group controlId="formPhone" className="mb-3">
//             <Form.Label>Phone *</Form.Label>
//             <Form.Control
//               type="text"
//               name="phone"
//               value={formData.phone}
//               onChange={handleChange}
//               isInvalid={!!errors.phone}
//             />
//             <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
//           </Form.Group>

//           <Form.Group controlId="formOffice" className="mb-3">
//             <Form.Label>Office</Form.Label>
//             <Form.Control
//               type="text"
//               name="office"
//               value={formData.office}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           <Form.Group controlId="formSummary" className="mb-3">
//             <Form.Label>Work Summary *</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               name="summary"
//               value={formData.summary}
//               onChange={handleChange}
//               isInvalid={!!errors.summary}
//             />
//             <Form.Control.Feedback type="invalid">{errors.summary}</Form.Control.Feedback>
//           </Form.Group>

//           <Form.Group controlId="formWeblink" className="mb-3">
//             <Form.Label>Webpage URL</Form.Label>
//             <Form.Control
//               type="text"
//               name="weblink"
//               value={formData.weblink}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           <Button 
//             variant="primary" 
//             type="submit"
//             disabled={isSubmitting}
//           >
//             {isSubmitting ? 'Updating...' : 'Update'}
//           </Button>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default EditFacultyModal;

import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Image, Alert } from 'react-bootstrap';
import axios from 'axios';
import { Base_Url } from '../config';
import { useSelector } from 'react-redux';

const EditFacultyModal = ({ modal, closeModal, editObj, fetchFaculty }) => {
  const [formData, setFormData] = useState({
    file: null,
    name: '',
    title: '',
    email: '',
    phone: '',
    summary: '',
    office: '',
    designation: '',
    weblink: '',
  });
  
  const [previewImage, setPreviewImage] = useState(null);
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const userfromwebmaster = useSelector((state) => state.user);
  const facultstaff = useSelector((state) => state.facultyuser);

  useEffect(() => {

    // console.log(editObj)
    if (editObj) {
      setFormData({
        file: null,
        name: editObj.name || '',
        title: editObj.title || '',
        email: editObj.email || '',
        phone: editObj.phone || '',
        summary: editObj.summary || '',
        office: editObj.office || '',
        designation: editObj.designation || '',
        weblink: editObj.website || '',
      });
      if (editObj.image) {
        setPreviewImage(`${Base_Url}/${editObj.image}`);
      }
      setSubmitError('');
    }
  }, [editObj]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (name === 'file' && files[0]) {
      setFormData(prev => ({
        ...prev,
        [name]: files[0]
      }));
      setPreviewImage(URL.createObjectURL(files[0]));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    const data = new FormData();
    
    if (formData.file) {
      data.append('image', formData.file);
    }
    
    Object.keys(formData).forEach(key => {
      if (key !== 'file' && formData[key]) {
        data.append(key, formData[key]);
      }
    });

    if (editObj.show_hod !== undefined) {
      data.append('show_hod', editObj.show_hod);
    }

    data.append('created_by', userfromwebmaster?.userExists ? 
      userfromwebmaster?.userData?.userid : 
      facultstaff?.facultyprofileData?.user_id
    );

    try {
      const response = await axios.put(`${Base_Url}/profile/${editObj.id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      
      if (response.data) {
        closeModal();
        fetchFaculty();
      }
    } catch (error) {
      console.error('Error updating faculty:', error);
      setSubmitError(
        error.response?.data?.error || 
        error.response?.data?.message || 
        'Failed to update faculty member. Please try again.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={modal} size="lg" onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Faculty Member</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {submitError && (
          <Alert variant="danger" className="mb-3">
            {submitError}
          </Alert>
        )}
        
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Profile Photo</Form.Label>
            <Form.Control
              type="file"
              name="file"
              onChange={handleChange}
              accept="image/png, image/jpeg, image/jpg, image/gif"
            />
            {previewImage && (
              <Image
                src={previewImage}
                alt="Preview"
                fluid
                className="mt-2"
                style={{ maxHeight: '200px' }}
              />
            )}
          </Form.Group>

          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="formName" className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group controlId="formDesignation" className="mb-3">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  type="text"
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="formEmail" className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group controlId="formPhone" className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
          </div>

          {/* <Form.Group controlId="formOffice" className="mb-3">
            <Form.Label>Office</Form.Label>
            <Form.Control
              type="text"
              name="office"
              value={formData.office}
              onChange={handleChange}
            />
          </Form.Group> */}

          <Form.Group controlId="formSummary" className="mb-3">
            <Form.Label>Work Summary</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="summary"
              value={formData.summary}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group controlId="formWeblink" className="mb-3">
            <Form.Label>Webpage URL</Form.Label>
            <Form.Control
              type="text"
              name="weblink"
              value={formData.weblink}
              onChange={handleChange}
            />
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button 
              variant="secondary" 
              onClick={closeModal}
            >
              Cancel
            </Button>
            <Button 
              variant="primary" 
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Updating...' : 'Update'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditFacultyModal;